import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InvestmentMasterModel } from "../../all_Interfaces";
import { RootState } from "../store";
import { getApiCall } from "../../services/apiHelper";
import { InvestmentServiceURL } from "../../config/config";
import { ServiceName } from "../../constants";



interface InitialState {
    data: InvestmentMasterModel,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as InvestmentMasterModel,
    error: '',
    loading: false
}

export const getInvestmentMaster = createAsyncThunk(
  "getInvestmentMaster",
  async (investmentId:string, { getState, rejectWithValue }) => {
    try {
      const response = await getApiCall<any>(
        InvestmentServiceURL + "/investments/getbyId?id=" + investmentId,
        ServiceName.INVESTMENTSERVICE
      );
      console.log(response);
      return response.result;
    } catch (error:any) {
      console.error("Error in POST request:", error);
      return rejectWithValue(error.message);
    }
  }
);

const addUpdateInvestmentMasterSlice:any = createSlice({
    name: "addUpdateInvestmentMaster",
    initialState,
    reducers: {
        addInvestmentMaster(state,action:PayloadAction<InvestmentMasterModel>){
            state.data = action.payload;
        },
        updateInvestmentMaster(state, action: PayloadAction<InvestmentMasterModel>) {
            state.data = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
          .addCase(getInvestmentMaster.pending, (state,action) => {
            state.loading = true;
          })
          .addCase(
            getInvestmentMaster.fulfilled,
            (state, action: PayloadAction<InvestmentMasterModel>) => {
              state.loading = false;
              state.data = action.payload;
              state.error = "";
    
            }
          )
          .addCase(getInvestmentMaster.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "Something went wrong";
          });
      },
});

export const { addInvestmentMaster,updateInvestmentMaster } = addUpdateInvestmentMasterSlice.actions;

export default addUpdateInvestmentMasterSlice.reducer;